var jade = require("/build/customer-ui/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><button id=\"CCCheckout\" type=\"button\" ng-click=\"stripeCheckout()\" class=\"btn btn-secondary\"><i class=\"fa fa-credit-card\"></i> Pay with Credit Card</button></div>");;return buf.join("");
}


// WEBPACK FOOTER //
// ./source/client/layout-components/stripe-payment/stripe-payment.jade